<template>
    <el-card >
        <el-drawer title="" :visible.sync="showMembers" direction="rtl" :before-close="getVoters" size="50%"
        :destroy-on-close="true">
        <div >
          <barangay-voters-list :barangay="barangay" :leader="selected"></barangay-voters-list>
        </div>
      </el-drawer>

          <div class="row">
            <div class="col-md-12">
               <h5>Leaders</h5>
            </div>
          <div class="col-sm-6">
            <el-select class="select-default" v-model="pagination.perPage" placeholder="Per page" size="small">
              <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input class="input-sm" placeholder="Search" v-model="term" addon-right-icon="nc-icon nc-zoom-split">
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped" header-row-class-name="text-primary" :data="voters" style="width: 100%">  
              <el-table-column :min-width="120" 
               class-name="td-actions" label="Name">
                <template slot-scope="props">
                  {{ props.row.full_name }}<br>
                  <div>CODE: {{ props.row.code }}</div>
                  <div>COMELEC ID: {{ props.row.comelec_id }}</div>
                  <div>PRECINT NO: {{ props.row.precint_number }}</div>
                </template>
              </el-table-column>

              <el-table-column :min-width="120" 
               class-name="td-actions" label="Barangay">
                <template slot-scope="props">
                  <div v-if="props.row.is_leader">Members: {{ props.row.members_count }}</div>
                </template>
              </el-table-column>

              <el-table-column :min-width="120" 
               class-name="td-actions" label="Address">
                <template slot-scope="props">
                  Purok: {{ props.row.purok }}
                  <div>{{ props.row.full_address }}</div>
                </template>
              </el-table-column>

              <el-table-column :min-width="120" 
               class-name="td-actions" label="Contact Info">
                <template slot-scope="props">
                  <div>Birth Date: {{ props.row.birth_date }}</div>
                  <div>Phone: {{ props.row.contact_number }}</div>
                  <div>Email: {{ props.row.email }}</div>
                </template>
              </el-table-column>
              
              <el-table-column :min-width="120" 
               class-name="td-actions" label="Actions">
                <template slot-scope="props">
                  <div>
                    <el-button type="default" link @click="handleAssign(props.row)">
                    Manage Members
                  </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Found {{ pagination.total }} data</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
              :total="pagination.total">
            </p-pagination>
          </div>
          </div>
        </el-card>
  </template>
  <script>
  
  import { Voter } from '@/resources/voter'
import BarangayVotersList from './BarangayVotersList.vue'
  
  export default {
    components: {BarangayVotersList },
    props: ['barangay', 'update'],
    data() {
        return {
        loading: false,
        showForm: false,
        voters: [],
        selected: null,
        perPageOptions: [5, 10, 15],
        pagination: {
          perPage: 10,
          currentPage: 1,
          total: 0
        },
        term: null,
        position: null,
        showMembers: false
      }
    },
    watch: {
      term: function () {
        if (!this.term || this.term.length > 2) {
          this.getVoters()
        }
      },
      'pagination.perPage': function () {
        if (this.pagination.currentPage == 1) {
          this.getVoters()
        } else {
          this.pagination.currentPage = 1
        }
      },
      'pagination.currentPage': function () {
        this.getVoters()
      },
      update: function () {
        this.getVoters()
      },
    },
    created: function () {
      this.getVoters()
    },
    methods: {
        handleClose(){
            this.showMembers = false
        },
        handleAssign(model){
            this.showMembers = true
            this.selected = Object.assign({}, model)
        },
      getVoters() {
        let params = { term: this.term, position: 'leader', page: this.pagination.currentPage, per_page: this.pagination.perPage, barangay_id: this.barangay.id }
        this.loading = true
        this.handleClose()
        Voter.get(params)
          .then(result => {
            this.pagination = result.data.meta
            if (result.data.voters)
              this.voters = result.data.voters
          })
          .catch(() => {
            this.$notify({
              type: 'danger',
              title: "Error",
              text: 'Unable to fetch leaders',
            });
  
          }).finally(() => {
            this.loading = false
          })
      },
    }
  }
  </script>
  <style lang="scss"></style>
  